import { render, staticRenderFns } from "./operaposterTemplateWindow.vue?vue&type=template&id=2ea23757"
import script from "./operaposterTemplateWindow.vue?vue&type=script&lang=js"
export * from "./operaposterTemplateWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports